<template>
    <div class="RankByKeywordPage">
        <zPage :sidebar="true"
               :contentState="pageContentState">
            <template v-slot:headerTitle>{{ gettext('Сравнение позиций филиалов по ключевому запросу') }}</template>
            <template v-slot:headerDescription>{{ gettext('Модуль оценки результатов продвижения карточек филиалов.') }}
                <a @click="modal1 = true"
                   class="a-button a-button--link a-button--action">{{ gettext('Подробнее') }}</a>
            </template>
            
            <template v-slot:topBar>
                <div class="buttonGroup">
                    <button class="button button--system" v-on:click="goToList()"><i class="fa fa-arrow-left"></i>{{ gettext('Вернуться к списку') }}</button>
                </div>
            </template>

            <template v-slot:main>
                <div class="xCard xCard--column">
                    <div class="xCard__header">
                        <div>
                            <div class="xCard__description">{{ gettext('Ключевик') }}</div>
                            <div class="xCard__title">{{keyword.name}}</div>
                        </div>
                        <div>
                            <div class="xCard__description">{{ gettext('Частотность') }}</div>
                            <div style="margin-top: 6px;">{{keyword.frequency}}</div>
                        </div>
                        <!--                    <div>-->
                        <!--                        <div class="xCard__description">Позиция</div>-->
                        <!--                        <div style="margin-top: 6px;">{{keyword.position}}</div>-->
                        <!--                    </div>-->
                    </div>
                    <div class="xCard__body">
                        <zPaginator ref="paginator"
                                    :paginator="paginator"
                                    :pending="domains.keywordStats.query.pending"
                                    @changePage="changePage"
                                    @changePageSize="changePageSize">
                            <div class="tableGroup">
                                <zTable v-bind="tableState" @sort="sortBy"></zTable>
                                <zTable v-bind="tableState__source" @onPositionInfoClick="showPositionHistory"></zTable>
                            </div>
                        </zPaginator>
                    </div>

                    <zPopup :custom-options="historyPopupOptions" :multi-trigger="true" ref="positionHistoryPopup">
                        <div class="popup__header">{{ gettext('История позиций') }}</div>

                        <div v-if="historyPopupOptions.positionHistory.length">
                            <div class="popup__item popup__item--noPointer" v-for="item of historyPopupOptions.positionHistory" :key="item.date">
                                {{ item.date }} - {{ item.position === null ? '---' : item.position }} </div>
                        </div>

                        <div v-else class="popup__noData">{{ gettext('Данных нет') }}</div>
                    </zPopup>
                </div>
            </template>

            <template v-slot:sidebar>
                <div class="statsDateInfo">
                    <div class="__showDate">{{ gettext('Статистика за') }} {{ statsForDate }}</div>
                    <div class="__nextDate">{{ gettext('Следующее обновление') }} {{ nextStatsUpdate }}</div>
                </div>

                <FilterBlock :query="domains.keywordStats.query"
                             :filters="filterFields"
                             @filterQueryParamChanged="getKeywordStats"></FilterBlock>
            </template>
        </zPage>

        <Modal v-model="modal1"
               :title="gettext('Информация о разделе')"
               footer-hide>
            <div class="about-repometr">
                <div class="info-block info-block--flat">
                    <div class="info-block__title">{{ gettext('На этой странице вы можете узнать:') }}</div>
                    <div class="info-block__body">
                        <ul>
                            <li>{{ gettext('частотность ключевых запросов (число запросов пользователей в месяц в популярной поисковой системе, например, Яндекс). Чем выше частотность, тем чаще пользователи интересуются товарами и услугами вашей компании, используя данный запрос для их поиска;') }}</li>
                            <li>{{ gettext('позиции карточек филиала компании на Яндекс.Картах и Google Maps (место карточки филиала в картографическом блоке результатов выдачи по поисковым запросам, чем выше позиция, тем лучше);') }}</li>
                            <li>{{ gettext('динамику еженедельных изменений таких позиций (в лучшем случае ваши позиции должны повышаться, а карточка должна быть в топ-3 выдачи по ключевым словам. Это гарантирует, что каждый потенциальный клиент узнает о вашей компании).') }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </Modal>

        <!--    <pre style="margin-top: 30px; padding: 20px; background: #fafafa">{{ domains.keywordStats.query | prettyJson }}</pre>-->
    </div>
</template>

<script>
import {makeBaseComponent} from "@/2_app-logic/models";
import {
    ColumnTypes,
    getColumnsForSourceTable, makeSourceDataForTable_branchGroup,
    sourceColumnsCountStyle
} from "@/2_app-logic/utils/utils";
import FilterBlock from "@/3_view/components/FilterBlock";
import zPage from "@/3_view/core/zPage";
import zPaginator from "@/3_view/core/zPaginator";
import zPopup from "@/3_view/core/zPopup";
import zTable from "@/3_view/core/zTable";
import {api} from "@/main";
import {createNamespacedHelpers} from "vuex";

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('RankByKeyword');

export default {
    name: 'RankByKeyword',
    components: {
        zTable, zPage, zPaginator, FilterBlock, zPopup,
    },
    props: {
        isDemoPage: Boolean
    },
    mixins: [makeBaseComponent({ mapState, mapGetters, mapActions })],
    data() {
        return {
            modal1: false,
            columns: [
                {
                    name: this.gettext('Филиалы'),
                    type: ColumnTypes.string,
                    isAscSort: true,
                    isSort: false,
                    isSortable: false,
                    sortingKey: 'branch',
                },
                // {
                //     name: this.gettext('Позиция'),
                //     type: ColumnTypes.integer,
                //     isAscSort: true,
                //     isSort: false,
                // },
            ],
            filterFields: [
                'branch_name',
                // 'source_id',
                // 'date'
            ],
            keywordId: null,
            historyPopupOptions: {
                popupId: 'positionHistoryPopup',
                triggerElUniqSelector: '#LocalPack .tableCell__content.--clickable.showInfoPopup',
                containerElUniqSelector: '#LocalPack .xCard .tableGroup',
                positionHistory: [],
                heightCompensation: 22,
                widthCompensation: 10,
            },
        }
    },
    computed: {
        ...mapState([
            'domains',
        ]),
        ...mapGetters([
            'stats',
            'paginator',
            'time',
            'keyword',
        ]),
        columnsNameMap() {
            /*hint:
            ключи Object'а нельза оборачивать функциями gettext -> 
            сначала создать new Map с переведенными ключами -> 
            потом перевести Map в Object
            */
            const transColumns = [this.gettext('Филиалы'), this.gettext('Частотность'), this.gettext('Позиция')]
            let transMap = new Map();
            transMap.set(transColumns[0], 'name');
            transMap.set(transColumns[1], 'frequency');
            transMap.set(transColumns[2], 'position');
            const res = Object.fromEntries(transMap)
            return res;
        },
        isInitDataReady() {
            return !!(this.paginator && this.stats && this.stats.length)
        },
        pageContentState() {
            return {
                pending: this.domains.keywordStats.query.pending,
                isInitDataReady: this.isInitDataReady,
                notExistText: this.gettext('Список филиалов пуст'),
            }
        },
        statsForDate() {
            const time = this.time && this.time.statsForDate
            return time ? new Date(time).toLocaleDateString() : ''
        },
        nextStatsUpdate() {
            const time = this.time && this.time.nextStatsUpdate
            return time ? new Date(time).toLocaleDateString() : ''
        },
        columns__source() {
            return getColumnsForSourceTable(this.stats)
        },
        data__source() {
            return makeSourceDataForTable_branchGroup(this.stats)
        },
        tableState__source() {
            return {
                data: this.data__source,
                columns: this.columns__source,
                rowStyle: this.rowStyle__source,
                isZebraStyle: true,
                type: 'source',
                cellMinWidth: '160px',
                positionInfoTooltip: this.gettext('Посмотреть историю'),
            }
        },
        tableState() {
            return {
                data: this.stats,
                columns: this.columns,
                rowStyle: this.rowStyle,
                columnsNameMap: this.columnsNameMap,
                type: 'usual'
            }
        },
        rowStyle() {
            return {'grid-template-columns': '1fr minmax(100px, 120px)'}
        },
        rowStyle__source() {
            return {'grid-template-columns': sourceColumnsCountStyle(this.columns__source.length)}
        }
    },
    methods: {
        ...mapActions([
            'fetchKeywordStats',
            'fetchKeyword',
            'sortBy',
        ]),
        async getKeywordStats() {
            await this.fetchKeywordStats({keyword: this.keywordId})
        },
        async getKeyword() {
            await this.fetchKeyword({keyword: this.keywordId})
        },
        goToList() {
            this.$router.push({name: 'KeywordList'})
        },
        async showPositionHistory(event, source) {
            if (!source) {
                console.warn('В таблице нет данных по этому источнику.')
                return
            }
            this.historyPopupOptions.positionHistory = await api.common.getRankByKeywordPositionHistory(source.branchId, source.id, this.keyword.name)

            if (!this.historyPopupOptions.positionHistory) {
                console.error('positionHistory is empty')
            }

            this.$refs.positionHistoryPopup.triggerElementClickHandler(event)
        },
    },
    async mounted() {
        this.keywordId = this.$route.params.id || (this.$route.query && this.$route.query.keyword)
        await this.getKeyword()
        await this.getKeywordStats()
    },
}
</script>